export const hasKnownCommentCount = (countsByPostId = {}, postId = "") =>
  Object.prototype.hasOwnProperty.call(countsByPostId, postId);

export const getHydratedCommentCount = (post = {}, countsByPostId = {}) => {
  if (post?.id && hasKnownCommentCount(countsByPostId, post.id)) {
    return Number(countsByPostId[post.id]) || 0;
  }

  const storedCount = Number(post?.commentCount);
  if (Number.isFinite(storedCount) && storedCount > 0) {
    return storedCount;
  }

  return null;
};

export const getPostsNeedingCommentCountHydration = (posts = [], countsByPostId = {}) =>
  posts
    .filter((post) => post?.id)
    .filter((post) => !hasKnownCommentCount(countsByPostId, post.id))
    .map((post) => post.id);

export const mergeCommentCount = (countsByPostId = {}, postId = "", count = 0) => {
  if (!postId) return countsByPostId;

  return {
    ...countsByPostId,
    [postId]: Math.max(0, Number(count) || 0),
  };
};
